import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {DmsDataGrid} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface RequestsSegmentProps extends RequiredTestIdProps {
  receiveNoteItemId: string | Nullish;
}

export function RequestsSegment(props: RequestsSegmentProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {receiveNoteItemId: props.receiveNoteItemId}]),
    [props.receiveNoteItemId]
  );

  return (
    <DmsDataGrid
      gridCode="receive-note-item-requests"
      queryModifier={queryModifier}
      autoHeight
      data-testid={suffixTestId('requests', props)}
    />
  );
}
